import { PixelIcon } from "./PixelIcon";
import type { MenuId, MeterView } from "./view-model";

export type MeterId = MeterView["id"];
export type DockActionId = "feed" | "play" | "rest" | "wash" | "pet";

export const METER_LABELS: Record<MeterId, string> = {
  food: "Food",
  rest: "Rest",
  fun: "Fun",
  clean: "Clean",
  love: "Love",
};

/** 8x8 pixel bitmaps from docs/handoff/006-shell-reference.html (BM). */
export const BM: Record<MeterId, readonly string[]> = {
  food: ["........", "..#.#.#.", "........", "#......#", "########", ".######.", "..####..", "........"],
  rest: ["..####..", ".##.....", "##......", "##......", "##......", ".##...##", "..######", "........"],
  fun: ["..####..", ".#.##.#.", "#..##..#", "########", "#..##..#", ".#.##.#.", "..####..", "........"],
  clean: ["...##...", "...##...", "..####..", ".######.", "########", "########", ".######.", "..####.."],
  love: [".##..##.", "########", "########", "########", ".######.", "..####..", "...##...", "........"],
};

/** METERS metadata from docs/handoff/006-shell-reference.html. */
export const METERS_META: ReadonlyArray<{
  k: MeterId;
  n: string;
  b: MeterId;
  c: string;
  a: string;
}> = [
  { k: "food", n: "Food", b: "food", c: "#ff9f43", a: "Feed" },
  { k: "rest", n: "Rest", b: "rest", c: "#7ea6ff", a: "Rest" },
  { k: "fun", n: "Fun", b: "fun", c: "#ffd54a", a: "Play" },
  { k: "clean", n: "Clean", b: "clean", c: "#5fd7e6", a: "Wash" },
  { k: "love", n: "Love", b: "love", c: "#ff8fb1", a: "Pet" },
];

/** Dock care actions in exact reference order (ACTS in docs/handoff/006-shell-reference.html). */
export const ACTS: ReadonlyArray<{
  id: DockActionId;
  name: string;
  m: MeterId;
}> = [
  { id: "feed", name: "Feed", m: "food" },
  { id: "play", name: "Play", m: "fun" },
  { id: "rest", name: "Rest", m: "rest" },
  { id: "wash", name: "Wash", m: "clean" },
  { id: "pet", name: "Pet", m: "love" },
];

const METER_ICON: Record<MeterId, string> = { food: "food", rest: "rest", fun: "play", clean: "wash", love: "love" };
const DOCK_ICON: Record<DockActionId, string> = { feed: "food", play: "play", rest: "rest", wash: "wash", pet: "love" };

/** Meter icon: the same 16 x 16 art as the dock (PixelIcon). */
export function MeterIcon({ id }: { id: MeterId }) {
  return <PixelIcon name={METER_ICON[id]} />;
}

/** Dock key icon (PixelIcon). */
export function DockIcon({ id }: { id: DockActionId }) {
  return <PixelIcon name={DOCK_ICON[id]} />;
}

/** Menu bar and More sheet icon (PixelIcon): the menu id is the icon name. */
export function MenuIcon({ id }: { id: MenuId }) {
  return <PixelIcon name={id} />;
}
